<script setup lang="ts">
defineOptions({
	name: 'IconDocument',
})

interface Props {
	class?: string
}

const props = withDefaults(defineProps<Props>(), {
	class: 'text-neutral-50 w-8 h-8',
})
</script>

<template>
	<svg
		:class="props.class"
		viewBox="0 0 57 57"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M19.1211 30.6867H37.6662"
			stroke="currentColor"
			stroke-width="3.47721"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M19.1211 39.9592H37.6662"
			stroke="currentColor"
			stroke-width="3.47721"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M14.4839 7.50537H35.7459C36.9745 7.50537 38.1544 7.9945 39.0237 8.8638L45.5794 15.4195C46.4487 16.2888 46.9379 17.4687 46.9379 18.6973V44.5956C46.9379 47.1571 44.8631 49.2319 42.3016 49.2319H14.4839C11.9224 49.2319 9.84766 47.1571 9.84766 44.5956V12.1416C9.84766 9.5801 11.9224 7.50537 14.4839 7.50537Z"
			stroke="currentColor"
			stroke-width="3.47721"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M46.9383 19.0961H37.6658C36.3862 19.0961 35.3477 18.0575 35.3477 16.7779V7.50537"
			stroke="currentColor"
			stroke-width="3.47721"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M19.1211 21.4142H26.0755"
			stroke="currentColor"
			stroke-width="3.47721"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>
